import { IonCard } from "@ionic/react";
import { ReactNode, useRef } from "react";
import { FormattedMessage } from "react-intl";

import ExpandableSection from "@components/animations/ExpandableSection";
import styles from "@components/carePlan/CarePlan.module.css";
import Icon from "@components/text/Icon";
import BodyCopy from "@components/typography/BodyCopy";
import { Opener } from "@hooks/useOpener";
import { Colors } from "@utils/colorUtils";
import { IconName } from "@utils/iconUtils";

type Props = {
  children: ReactNode;
  count: number;
  icon: IconName;
  iconColor: Colors;
  opener: Opener;
  skip?: boolean;
  titleKey: string;
};

const GoalEditorSection = ({ children, count, icon, iconColor, opener, skip, titleKey }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  if (skip) {
    return (
      <div>
        <ExpandableSection initial={false} isOpen={opener.isOpen}>
          <div>{children}</div>
        </ExpandableSection>
      </div>
    );
  }

  return (
    <div className={styles.goalEditorSection}>
      <div className={styles.goalEditorHeader} onClick={opener.toggle} ref={ref}>
        <div>
          <IonCard className={styles.goalEditorHeaderIcon} color={iconColor}>
            <Icon color="white" icon={icon} size="small" />
          </IonCard>
        </div>

        <div className={styles.noWrap}>
          <BodyCopy color="primary">
            <FormattedMessage id={titleKey} />
          </BodyCopy>
        </div>
        <div>
          <Icon color="primary" icon={opener.isOpen ? "chevronUp" : "chevronDown"} />
        </div>

        <div className={styles.goalEditorCountContainer}>
          <div className={styles.goalEditorCount}>
            <BodyCopy color="primary" size="small">
              {count}
            </BodyCopy>
          </div>
        </div>
      </div>
      <ExpandableSection initial={false} isOpen={opener.isOpen}>
        <div>{children}</div>
      </ExpandableSection>
    </div>
  );
};

export default GoalEditorSection;
